const inlineMd_component = {
	group: "inline",
	atom: true,
	inline: true,
	attrs: {
		text: { default: null },
		tag: { default: null },
	},
};

export default inlineMd_component;
